import { QueryHookOptions, useQuery } from "@apollo/react-hooks";

import { InstructorBusinessProfile } from "../../../graph-ql/types/gateway";
import getInstructorBusinessProfile from "../graph-ql/getInstructorBusinessProfile.graphql";

const useQueryInstructorBusinessProfile = (opts?: QueryHookOptions) =>
  useQuery<{ getInstructorBusinessProfile: InstructorBusinessProfile }>(
    getInstructorBusinessProfile,
    opts,
  );

export default useQueryInstructorBusinessProfile;
